import VenueSuggestionItem from 'components/AddressModal/components/VenueSuggestionItem/styled';

export default VenueSuggestionItem;
